import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import Counter from '@/components/base/Counter';
import { resultsStats } from '@/mocks/results';

export default function ResultsHero() {
  return (
    <section className="relative w-full px-5 md:px-10 pt-16 md:pt-20 pb-16 md:pb-20">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Результаты"
          title="Цифры, которые говорят сами за себя"
          description="240+ сообществ, 12 млн подписчиков и 340 тысяч заявок — итог системы, а не случайных удач. Здесь мы показываем, как растут наши клиенты."
        />

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {resultsStats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 80}>
              <div className="h-full p-6 rounded-lg bg-background-100/70 border border-background-200/70 text-center">
                <div className="font-heading font-bold text-3xl md:text-4xl text-primary-500">
                  <Counter value={stat.value} suffix={stat.suffix} />
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}